export const MESSAGE_WIDTH = 50;
export const MESSAGE_HEIGHT = 20;

export const MARGIN = 10;
export const MARGIN_BIG = MARGIN * 2;
export const MARGIN_MESSAGE = MESSAGE_WIDTH + MARGIN;

export const TIMELINE_WIDTH = 500;
export const TIMELINE_HEIGHT = MESSAGE_HEIGHT + MARGIN * 2;
export const NODE_HEIGHT = 5 * TIMELINE_HEIGHT;

export const PRODUCER_HEIGHT = TIMELINE_HEIGHT + MARGIN + MARGIN_BIG * 2;

export const BUTTON_SIZE = MESSAGE_HEIGHT + MARGIN;
export const BUTTON_ICON_SIZE = 14;

export const TIMELINE_MARGIN = BUTTON_SIZE * 2 + MARGIN;

export const TOOLTIP_OFFSET = 45;
export const TOOLTIP_TIMEOUT = 10;

export const DASHES = [5, 5];
export const DOTS = [1, 3];

export const STROKE_WIDTH = 2;

export const DISABLED_OPACITY = 0.25;

export const BACKGROUND = 0xf0f2f5;
export const WHITE = 0xffffff;
export const BLACK = 0x000000;
export const GRAY = 0x828384;
export const SML_COLORS = [
    0x324891,
    0x5bb12f,
    0x9e579e,
    0x73c5e1,
    0xeb65a0,
    0x257dbe,
    0xb96fab,
    0xbccf02,
];
export const BUTTON_PRIMARY_COLOR = 0x1890ff;
export const BUTTON_DANGER_COLOR = 0xff4d4f;
export const BUTTON_SUCCESS_COLOR = 0x52c41a;

export const TIMELINE_MESSAGES_LIMIT = 25;
export const CONSUMER_MESSAGES_LIMIT = 25;
export const PRODUCER_BUFFER_SIZE = 25;

export const ANIMATION_STAGES = 5;
